<template>
  <v-card v-if="timberCategory" id="timber-category-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text class="text-right">
      <v-text-field
      class="py-6"
      v-model="timberCategory.name"
      :rules="[rules.required]"
      :label="$t('name')"
      color="black"
      :counter="maxNameLength"
      :maxlength="maxNameLength"
      ref="timberCategoryName"/>
      <v-btn id="timber-category-submit" color="primary" @click="submitClicked" :disabled="!canSubmit">
        {{ buttonText }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import fieldRules from '@/utils/rules.js'
import { StringConstants } from '@/utils/constants'

export default {
  name: 'TimberCategoryForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propTimberCategory: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created () {
    if (this.propTimberCategory) {
      this.timberCategory = cloneDeep(this.propTimberCategory)
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.timberCategoryName.focus()
      document.addEventListener('keyup', this.onKeyup)
    }, 0)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyup)
  },

  computed: {
    editing () {
      return this.timberCategory?.timberCategoryId
    },

    title () {
      return this.editing ? this.$t('editTimberCategory') : this.$t('createNewTimberCategory')
    },

    buttonText () {
      return this.editing ? this.$t('saveChanges') : this.$t('create')
    },

    canSubmit () {
      return this.timberCategory.name.length > 0 && this.timberCategory.name.length <= this.maxNameLength
    }
  },

  data: () => ({
    timberCategory: {
      name: ''
    },
    maxNameLength: StringConstants.MediumStringLength,
    rules: fieldRules.rules
  }),

  methods: {
    ...mapActions('tract', ['createTimberCategory', 'updateTimberCategory']),

    async submitClicked () {
      if (this.canSubmit) {
        this.editing ? await this.updateTimberCategory(this.timberCategory) : await this.createTimberCategory(this.timberCategory)
        this.$emit('timber-category-mutated')
      } else {
        this.setSnackError(this.$t('nameIsRequired'))
      }
    },

    onKeyup (e) {
      if (e.key.toLowerCase() === 'enter') {
        this.submitClicked()
      }
    }
  }
}
</script>
